//time taken for that time
export function getTimeSpent(minutesPractice, secondsPractice, isUI) {
  if (isUI) {
    return minutesPractice + " : " + ("0" + secondsPractice).slice(-2);
  } else {
    return minutesPractice + ":" + ("0" + secondsPractice).slice(-2);
  }
}

//overall time taken for the activity
export function getTimeSpentOverall(minutes, seconds, isUI) {
  if (isUI) {
    return minutes + " : " + ("0" + seconds).slice(-2);
  } else {
    return minutes + ":" + ("0" + seconds).slice(-2);
  }
}

export function getSubmitDate() {
  let d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hr = ("0" + d.getHours()).slice(-2),
    min = ("0" + d.getMinutes()).slice(-2),
    sec = ("0" + d.getSeconds()).slice(-2);
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-") + " " + [hr, min, sec].join(":");
}
